export const SvgPlus = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className="mr-1 self-center"
  >
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#9BFF9B"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 5v14M5 12h14"
      />
    </g>
  </svg>
);
